import { useContext } from 'react'

import { launchModal } from '@domain-group/javascript-utils'
import {
  useForm, useLatestEntity, useThunkDispatch,
} from '@domain-group/react-hooks'

import useSelector from '@hooks/useSelector'

import defaultState, { BrandThemeModel, requiredFields } from '@models/brandTheme'

import * as brandThemeActions from '@redux/modules/brandTheme'

import PageContext from '@contexts/pageContext'

import { BrandModel } from '@models/brand'
import { AppDispatch } from '@redux/store'

export const generateUrls = () => ({
  brandThemesIndexUrl: '#/systemManager/brandThemes',
})

type createBrandThemeParams = {
  brandThemeParams: Partial<BrandThemeModel>,
  dispatch: AppDispatch,
}

const createBrandTheme = (params: createBrandThemeParams) => {
  const { brandThemeParams, dispatch } = params
  const { createBrandTheme: createFn } = brandThemeActions

  // @ts-expect-error TS2345
  return dispatch(createFn(brandThemeParams))
}

type UpdateBrandThemeParams = {
  brandTheme: BrandThemeModel,
  brandThemeParams: Partial<BrandThemeModel>,
  dispatch: AppDispatch,
}

const updateBrandTheme = (params: UpdateBrandThemeParams) => {
  const { brandTheme, brandThemeParams, dispatch } = params
  const { updateBrandTheme: updateFn } = brandThemeActions

  const updatedParams = {
    id: brandTheme.id,
    ...brandThemeParams,
  }

  return dispatch(updateFn(updatedParams))
}

export function useBrandThemeForm(brandTheme: Partial<BrandThemeModel> = {}) {
  const brandThemeForm = useForm(defaultState, { entity: brandTheme, requiredFields }, [brandTheme.id])

  return {
    ...brandThemeForm,
  }
}

type UseRelationsPayload = {
  brand: Partial<BrandModel>,
}

export function useRelations(
  brandTheme: Partial<BrandThemeModel> = {},
): UseRelationsPayload {
  const { brand_id } = brandTheme || {}

  const brands = useSelector(reduxState => reduxState.entities.brands)

  const brand: Partial<BrandModel> = brand_id ? brands[brand_id] || {} : {}

  return {
    brand,
  }
}

function useBrandTheme(initEntity: Partial<BrandThemeModel> = {}) {
  // @ts-expect-error TS2345
  const { entity: brandTheme } = useLatestEntity(initEntity, 'brandThemes')

  const dispatch = useThunkDispatch()

  const { callbacks } = useContext(PageContext)

  const { creating, updating } = useSelector(reduxState => reduxState.brandThemes)

  return {
    brandTheme,
    callbacks: {
      createBrandTheme: (
        brandThemeParams: Partial<BrandThemeModel>,
      ) => createBrandTheme({ brandThemeParams, dispatch }),
      createOrEditBrandTheme: () => launchModal({
        callbacks,
        modalKey: 'CreateOrEditBrandThemeModal',
        payload: { brandTheme },
      }),
      updateBrandTheme: (
        brandThemeParams: Partial<BrandThemeModel>,
      // @ts-expect-error TS2322
      ) => updateBrandTheme({ brandTheme, brandThemeParams, dispatch }),
    },
    creating,
    updating,
    urls: generateUrls(),
  }
}

export default useBrandTheme
